interface UnrecognizedLinesPanelProps {
  lines: string[];
}

const UnrecognizedLinesPanel = ({ lines }: UnrecognizedLinesPanelProps) => {
  if (lines.length === 0) return null;

  return (
    <div className='flex flex-col gap-1 p-3 rounded-lg bg-red-50 border border-red-100 max-h-[120px] overflow-y-auto'>
      <span className='text-red-900 font-bold text-[12px] uppercase tracking-wide'>
        No se reconocieron estas líneas:
      </span>
      <span className='text-red-700 text-[13px] font-mono break-all'>
        {lines.join(', ')}
      </span>
    </div>
  );
};

export default UnrecognizedLinesPanel;
